import {MESSAGES} from '../../core/constants/messages.constant';
import screens from './screen';
export default {
    transformDayOrMonth(value) {
        const result = (value).toString();
        return result.length > 1 ? result : `0${result}`;
    },
    lostTokenSales(notAvailable, message, title) {
        const hasTokenSales = localStorage.getItem('currentSalesApi') !== null;
        if (!hasTokenSales && !notAvailable) {
            return {notAvailable: !hasTokenSales, message: MESSAGES.ERROR_SALES_TOKEN, title};
        }
        return {notAvailable, message, title};
    },
    messageMaintenance(endOfMaintenance) {
        const month = this.transformDayOrMonth((endOfMaintenance.getMonth() + 1));
        const day = this.transformDayOrMonth(endOfMaintenance.getDate());
        const date = `${day}/${month}/${endOfMaintenance.getFullYear()}`;
        const time = this.getTime(endOfMaintenance);
        let message = MESSAGES.MAINTENANCE;
        message = message.replace('$date', date);
        message = message.replace('$time', time);
        return message;
    },
    isClosedCart(closed: boolean = true) {
        const notAvailable = closed;
        const title = '';
        const message = MESSAGES.CLOSED_CART;
        return {notAvailable, message, title};
    },
    lostToken() {
        const title = '';
        const startOfMaintenance = new Date(3000, 0, 0, 0, 0, 0);
        const endOfMaintenance = new Date(3000, 0, 0, 0, 0, 0);
        const message = this.messageMaintenance(endOfMaintenance);
        const currentDate = new Date();
        const notAvailable = currentDate > startOfMaintenance  && currentDate <= endOfMaintenance;
        return this.lostTokenSales(notAvailable, message, title);
    },
    isMaintenance() {
        return {notAvailable: false, message: '', title: ''};
        // return this.lostTokenSales();
        // return this.isClosedCart();
    },
    screens,
    isMatch(obj1: any, obj2: any) {
        return Object.keys(obj2).every(value => {
            if (typeof obj2[value] == 'object') {
                return this.isMatch(obj1[value], obj2[value]);
            }
            return obj2[value] === obj1[value];
        });
    },
    convertPrice(value: string | null) {
        return value ? value.replace('.', ',') : '0';
    },
    currencyFormat(amount: number, { locale = 'pt-BR', currency = 'BRL' } = {}) {
        return Intl
            .NumberFormat(locale, { style: 'currency', currency })
            .format(amount)
            .replace(String.fromCharCode(160), String.fromCharCode(32));
    }

};
